// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"SensorsTable_progressBar__2VU_g","cell":"SensorsTable_cell__mOxG8","headerCell":"SensorsTable_headerCell__3P0j0"};